import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { filter } from 'rxjs/operators';
import _set from 'lodash/set';

import PlaybackWrapper from 'bdvp-common/src/components/PlaybackWrapper';

import {
    useMediaConfigGame,
    useClub,
    useIsClubPage,
    useLang,
} from 'bdvp-common/src/hooks/config';
import { getDeviceInfo, getMlbNative } from 'bdvp-common/src/utils';

export const buildMediaItemAdConfig = ({ slug: vid } = {}) => {

    const { user = {} } = getMlbNative();
    const { isPremium = false, entitlements = [] } = user;
    const userEntitlements = isPremium ? entitlements.join(',') : 'free';
    return {
        vid,
        cust_params: {
            vid,
            aam_uuid: document.cookie.match(/aam_uuid=([^;]+)/)?.[1] || '',
            entitlement: userEntitlements,
        },
    };

};

const Player = (props) => {

    const {
        mediaItem,
        isEU,
        onReadyToPlay,
    } = props;

    const config = useMediaConfigGame();
    const club = useClub();
    const isClubPage = useIsClubPage();
    const lang = useLang();

    const deviceInfo = useMemo(() => getDeviceInfo() || {}, []);
    const { player:playerConfig = {} } = config;

    const {
        autoPlay = false,
        initConfig = {},
        playerOptions = {},
    } = playerConfig;
    const mediaConfig = { ...playerConfig.mediaConfig };
    const handleObservable = (observationCenter) => {

        observationCenter.playerSubject.pipe(filter((event) => {

            return event.type === 'showClickToPlay';

        })).subscribe(() => {

            onReadyToPlay();

        });

    };

    _set(mediaConfig, 'videocore.advertising.dfp.isEu', isEU);

    return (
        <PlaybackWrapper
            playbackContainerId={'game-player'}
            autoPlay={autoPlay}
            initConfig={{
                ...initConfig,
                dynamicAdConfig: {
                    buildMediaItemAdConfig,
                },
            }}
            mediaConfig={mediaConfig}
            playerOptions={{
                ...playerOptions,
                metaData: mediaItem,
                club,
                deviceInfo,
                deviceFormFactor: deviceInfo.formFactor,
                isClubPage,
                lang,
            }}
            handleObservable={handleObservable}
        />
    );

};

Player.propTypes = {
    mediaItem: PropTypes.object.isRequired,
    onReadyToPlay: PropTypes.func.isRequired,
    isEU: PropTypes.bool,
};

Player.defaultProps = {
    isEU: false,
};

export default Player;
